<template>
    <div>
        <b-modal
            id="modal-invoice-transaction"
            no-close-on-backdrop
            size="xl"
            @hidden="closeAndEmit"
            :title="i18nT(`Match transaction to invoice`)"
        >
            <!-- TRANSACTION DETAILS -->

            <b-row class="pt-1">
                <!-- FILTERS -->
                <b-col cols="6" >
                    <b-row>

                        <!-- FILTERS -->
                        <b-col
                            cols="12"
                            md="12"
                        >
                            <b-form-group>
                                <div
                                    role="group"
                                    class="input-group input-group-merge"
                                >
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <feather-icon icon="SearchIcon"/>
                                        </div>
                                    </div>
                                    <b-form-input
                                        v-model.lazy="searchQuery"
                                        :placeholder="i18nT(`Search by debtor name or transaction description`)"
                                        type="text"
                                        class="d-inline-block"
                                    />
                                </div>
                            </b-form-group>
                        </b-col>

                    </b-row>

                    <b-row class="border-bottom mb-2 pb-1 pt-1">
                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group :label="i18nT(`Bank Account`)">
                                <v-select
                                    v-model="bankAccount"
                                    :options="bankAccounts"
                                    :reduce="(e) => e.value == '' ? '' : parseInt(e.value)"
                                    label="text"
                                    :clearable="false"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group :label="i18nT(`Currency`)">
                                <v-select
                                    v-model="currency"
                                    :options="currencies"
                                    :reduce="(e) => e.value"
                                    label="text"
                                    :clearable="false"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group
                                :label="i18nT(`Transaction date range`)"
                                label-for="paymentType"
                            >
                                <b-input-group>
                                    <b-input-group-prepend>
                                        <b-button
                                            variant="primary"
                                            @click.stop="inputClick"
                                        >
                                            <font-awesome-icon :icon="['fas', 'calendar-alt']"/>
                                        </b-button>
                                    </b-input-group-prepend>
                                    <VueCtkDateTimePicker
                                        :id="'TransactionsDateRange'"
                                        class=""
                                        :range="true"
                                        :max-date="maxDate"
                                        :min-date="minDate"
                                        :disabled="false"
                                        v-model="reportRange"
                                        :only-date="true"
                                        :only-time="false"
                                        :format="`YYYY-MM-DD`"
                                        :formatted="dateFormat"
                                        :color="`#5a5aff`"
                                        :label="i18nT(`Select date`)"
                                        :button-now-translation="i18nT(`Today`)"
                                        :first-day-of-week="1"
                                        :no-button="true"
                                        :auto-close="true"
                                        :locale="locale"
                                        :ref="`transactionRangePicker`"
                                    />
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col
                            cols="12"
                            md="6"
                        >
                            <b-form-group
                                :label="i18nT(`Transaction range`)"
                                label-for="paymentType"
                            >
                                <b-row>
                                    <b-col
                                        cols="12"
                                        md="6">
                                        <b-form-input
                                            v-model="amountFrom"
                                            :placeholder="i18nT(`Amount from`)"
                                            type="number"
                                        ></b-form-input>
                                    </b-col>

                                    <b-col
                                        cols="12"
                                        md="6">
                                        <b-form-input
                                            v-model="amountTo"
                                            :placeholder="i18nT(`Amount to`)"
                                            type="number"
                                        ></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col
                            cols="12"
                            md="6">
                            <b-form-group
                                :label="i18nT(`Predefined filters`)"
                            >
                                <b-form-checkbox
                                    v-model="useInvoiceDetails"
                                    switch
                                    :value="true"
                                    :unchecked-value="false"
                                    @change="detailsToFilters"
                                >{{i18nT(`Use invoice details as filters`)}}</b-form-checkbox>
                            </b-form-group>

                        </b-col>

                        <b-col
                            cols="12"
                            md="6">
                            <b-form-group
                                :label="i18nT(`Update transaction list`)"
                            >
                                <b-button
                                    @click="syncAll"
                                    variant="outline-primary"
                                >
                                    <feather-icon icon="RefreshCcwIcon" class="mr-05"/>
                                    {{i18nT(`Sync new transactions`)}}
                                </b-button>
                            </b-form-group>


                        </b-col>
                    </b-row>

                </b-col>

                <!-- INVOICE DETAILS -->
                <b-col cols="6">
                    <b-card no-body class="py-1 px-2">
                        <div class="text-center my-1">
                            <h4>{{i18nT(`Invoice details`)}}</h4>
                        </div>

                        <div class="d-flex">
                            <div class="transaction-detail  mr-2">
                                <strong>{{i18nT(`Invoice #`)}}</strong>
                                <p>
                                    {{ invoice.Label }}
                                </p>
                            </div>
                            <div class="transaction-detail mr-2">
                                <strong>{{i18nT(`Date`)}}</strong>
                                <p>
                                    {{ invoice.InvoiceDate | date }}
                                </p>
                            </div>
                            <div v-if="invoice.VendorObj" class="transaction-detail mr-2">
                                <strong>{{i18nT(`Client`)}}</strong>
                                <p>
                                    {{ invoice.VendorObj.Label }}
                                </p>
                            </div>

                            <div v-if="invoice.PaymentType" class="transaction-detail mr-2">
                                <strong>{{i18nT(`Payment method`)}}</strong>
                                <p>
                                    {{ paymentMethodLabel }}
                                </p>
                            </div>

                            <div v-if="invoice.PaymentType == 1" class="transaction-detail mr-2">
                                <strong>{{i18nT(`Bank account`)}}</strong>
                                <p>{{ bankAccountLabel }}</p>
                            </div>



                        </div>
                        <div class="d-flex">
                            <div class="transaction-detail mr-2">
                                <strong>{{i18nT(`Total Amount`)}}</strong>
                                <p>{{
                                        {amount: invoice.Amount, currency: invoice.Currency} | currency }}
                                </p>
                            </div>

                            <div class="transaction-detail mr-2">
                                <strong>{{i18nT(`Open Balance`)}}</strong>
                                <p :class="invoice.DueAmount > 0 ? `text-danger` : `text-success`">{{
                                        {amount: invoice.DueAmount, currency: invoice.Currency} | currency }}
                                </p>
                            </div>

                        </div>
                    </b-card>
                </b-col>
            </b-row>

            <validation-observer ref="createInvoice">

                <!-- Invoice list -->
                <b-row>
                    <b-col cols="6">
                        <b-table
                            ref="refDocumentListTable"
                            id="invoiceListTable"
                            class="position-relative mt-3"
                            :items="fetchDocuments"
                            responsive
                            :fields="tableColumns"
                            primary-key="id"
                            :sort-by.sync="sortBy"
                            show-empty
                            :empty-html="emptyHtml"
                            :sort-desc.sync="isSortDirDesc"
                            @refreshed="onTableRefresh"
                            @row-clicked="onRowClicked"
                            :tbody-tr-class="rowClass"
                            v-model="currentItems"
                        >
                            <template #cell(amount)="data">
                                <p :class="data.item.Amount >= 0 ? `text-success` : `text-danger`">
                                    {{ {amount: data.item.Amount, currency: data.item.Currency} | currency }}</p>
                            </template>

                            <template #cell(name)="data">
                                <p class="font-small-2">
                                    {{ data.item.Label }}
                                </p>
                            </template>

                            <template #cell(bank_account)="data">
                                <p class="font-small-2" v-if="data.item.BankAccountObj">{{ data.item.BankAccountObj.Label }}</p>
                            </template>

                            <template #cell(currency)="data">
                                <p class="font-small-2">{{ data.item.Currency }}</p>
                            </template>

                            <template #cell(DebtorName)="data">
                                <p class="font-small-1" v-if="(data.item.Amount >= 0)">{{ data.item.DebtorName }}</p>
                                <p class="font-small-1" v-else>{{ data.item.CreditorName }}</p>
                            </template>

                            <template #cell(date)="data">
                                <p class="font-small-2">{{ data.item.TransactionDate | date }}</p>
                            </template>

                            <template #cell(status)="data">
                                <b-badge
                                    :variant="statusLabelClass(data.item.PaymentId)"
                                    class="mr-1 badge-pill">
                                    {{ data.item.PaymentId ? i18nT(`Matched`) : i18nT(`Unmatched`) }}
                                </b-badge>
                            </template>

                        </b-table>

                        <b-row>
                            <b-col
                                cols="12"
                                sm="6"
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-center justify-content-sm-start
                                  "
                            >

                                <span class="text-muted">{{ i18nT(`Showing`) }}
                            {{ dataMeta.from }} {{ i18nT(`to`) }}
                            {{ dataMeta.to }} {{ i18nT(`of`) }} {{ dataMeta.of }}
                            {{ i18nT(`entries`) }}</span>
                            </b-col>
                            <!-- Pagination -->
                            <b-col
                                cols="12"
                                sm="6"
                                class="
                                d-flex
                                align-items-center
                                justify-content-center justify-content-sm-end
                              "
                            >
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalDocuments"
                                    :per-page="perPage"
                                    first-number
                                    last-number
                                    class="mb-0 mt-1 mt-sm-0"
                                    prev-class="prev-item"
                                    next-class="next-item"
                                >
                                    <template #prev-text>
                                        <feather-icon
                                            icon="ChevronLeftIcon"
                                            size="18"
                                        />
                                    </template>
                                    <template #next-text>
                                        <feather-icon
                                            icon="ChevronRightIcon"
                                            size="18"
                                        />
                                    </template>
                                </b-pagination>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="6">
                        <transition-group name="fade" mode="out-in">
                            <div v-if="!selectedRow.Id" :key="`no-row`" class="d-flex justify-content-center align-items-center h-100">
                                <div class="text-center pt-2" >
                                    <h4>{{i18nT(`Select a transaction`)}}</h4>
                                    <p>{{i18nT(`Pick an item from the list on the left to link the transaction as a payment for this invoice`)}}</p>
                                </div>
                            </div>

                            <div v-else :key="`has-row`">
                                <p class="mb-2">{{i18nT(`Select or create new payment record to reflect this transaction in the invoice payment history`)}}</p>
                                <transition-group name="fade" mode="out-in">
                                    <div v-if="availablePayments.length > 0" :key="'table'">
                                        <b-table
                                            id="paymentsListTable"
                                            :items="availablePayments"
                                            :fields="paymentItemsFields"
                                        >
                                            <template #cell(checkbox)="data">
                                                <b-form-radio
                                                    v-model="selectedPreviousPayment"
                                                    :value="data.item.Id"
                                                    name="previousPayment"
                                                ></b-form-radio>
                                            </template>

                                            <template #cell(CreatedAt)="data">
                                                <div v-if="data.item.IsNew">
                                                    <span>{{ data.item.CreatedAt | date }}</span>
                                                    <b-badge  variant="primary" class="badge-pill ml-1">
                                                        {{i18nT(`Add New`)}}
                                                    </b-badge>
                                                </div>

                                                <div v-else>
                                                    <span>{{ data.item.CreatedAt | date }}</span>
                                                    <b-badge variant="secondary" class="badge-pill ml-1">
                                                        {{i18nT(`Existing`)}}
                                                    </b-badge>
                                                </div>
                                            </template>

                                            <template #cell(Amount)="data">
                                                <span>{{ {amount: data.item.Amount, currency: data.item.Currency, locale: curLocale} | currency }}</span>
                                            </template>

                                            <template #cell(PaymentType)="data">
                                                <font-awesome-icon
                                                    :icon="['fas', paymentTypeIcon(data.item.PaymentType)]"
                                                    class="mr-1"
                                                />
                                                <span v-if="PaymentTypeDict && PaymentTypeDict[data.item.PaymentType]"
                                                >{{ PaymentTypeDict[data.item.PaymentType] }}</span>
                                            </template>

                                            <template #cell(Description)="data">
                                                <span>{{ data.item.Description | truncate(50) }}</span>
                                            </template>


                                        </b-table>
                                    </div>
                                    <div class="text-center pt-2" v-else v-html="emptyHtmlPayments" :key="`no-payments`">
                                    </div>
                                </transition-group>
                            </div>
                        </transition-group>
                    </b-col>
                </b-row>


            </validation-observer>


            <!-- Modal Footer -->
            <template #modal-footer>
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="outline-secondary"
                        class="mr-2"
                        right
                        @click="cancel"
                    >
                        {{i18nT(`Cancel`)}}
                    </b-button>

                    <b-button
                        variant="primary"
                        right
                        @click="linkToPayment()"
                        :disabled="!canSave"
                    >
                        {{i18nT(`Save`)}}
                    </b-button>
                </div>
            </template>
        </b-modal>

    </div>


</template>

<script>

import {
    BCard,
    BRow,
    BCol,
    BButton,
    BModal,
    BTable,
    BBadge,
    VBTooltip,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormRadio, BPagination, BFormCheckbox
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
// import {required, email} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useAuth from "@/auth/useAuth";

import {avatarText} from "@core/utils/filter";
import {dictToSelectArray} from "@core/utils/utils";
import vSelect from "vue-select";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from "moment";
import useAbrigedTransactionList from "@/views/accounting/Transactions/useAbrigedTransactionList"
import useAbridgedTransactionList from "@/views/accounting/Transactions/useAbrigedTransactionList";

export default {
    name: "ModalInvoiceTransaction",
    components: {
        BFormCheckbox, BPagination,
        BFormGroup,
        BCard,
        BRow,
        BCol,
        BButton,
        BModal,
        BTable,
        BBadge,
        BFormInput,

        BInputGroup,
        BInputGroupPrepend,
        BFormRadio,
        vSelect,
        ValidationObserver,
        VueCtkDateTimePicker
    },
    directives: {
        'b-tooltip': VBTooltip
    },
    props: {
        invoice: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            curLocale: this.$i18n.locale,

            bankAccounts: [],
            currencies: [],
            useInvoiceDetails: true,



            paymentTypeList: [],

            selectedItems: [],
            selectedPreviousPayment: null,
            currentItems: [],

            selectedRow: {},
            availablePayments: [],
            PaymentTypeDict: [],
            selectedRowIndex: null,

            vendorList: [],
            paymentCategoryList: [],

            paymentItemsFields: [
                { key: 'checkbox', label: this.i18nT(``), thClass: 'tbl-chk', tdClass: 'tbl-chk' },
                { key: 'CreatedAt', label: this.i18nT(`Date`), sortable: true },
                { key: 'Amount', label: this.i18nT(`Amount`), sortable: true },
                { key: 'PaymentType', label: this.i18nT(`Via`), sortable: true }, //
                { key: 'Description', label: this.i18nT(`Description`), sortable: true },
            ],

            reportRange: {
                start: '',
                end: ''
            },

            vatPercent: 0,
            invoiceNumber: '',
            lastInvoiceNumber: '',

            saveAndEdit: false,
            dontRemind: false,
        }
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        },
        paymentMethodLabel() {
            if(this.invoice.PaymentType) {
                const paymentMethod = this.paymentTypeList.find(item => item.value == this.invoice.PaymentType);
                return paymentMethod ? paymentMethod.text : '';
            }else {
                return '';
            }
        },

        bankAccountLabel() {
            if(this.invoice.PaymentType == 1) {
                let accountId = this.invoice.BillingAccountId ? this.invoice.BillingAccountId : '';
                if(accountId) {
                    let accountName = this.bankAccounts.find(item => item.value == accountId);
                    return accountName ? accountName.text : '';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        },

        hasNewRecord(){
            return this.availablePayments.find(item => item.IsNew);
        },
        canSave(){
            return this.selectedItems.length ? true : false;
        },
        dateFormat() {
            return useAuth.getDateFormat() !== 'undefined'
                ? useAuth.getDateFormat()
                : 'DD/MM/YYYY'
        },
        minDate() {
            let theMinDate = this.invoice.InvoiceDate ? moment(this.invoice.InvoiceDate).subtract(5, 'days').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            return theMinDate;
        },
        maxDate() {
            return moment().format('YYYY-MM-DD');
        },
        documentType() {
            return this.invoice.Amount > 0 ? 1 : 2;
        },
        emptyHtml() {
            return "<img src='" + require('@/assets/images/pages/error.svg') + "' alt='Error page' class='img-fluid' width='300'><br/><br/><h4>" + this.i18nT(`No matching records found`) + "</h4>";
        },
        emptyHtmlPayments() {
            return "<img src='" + require('@/assets/images/pages/error.svg') + "' alt='Error page' class='img-fluid' width='300'><br/><br/><h4>" + this.i18nT(`No matching records found`) + "</h4>";
        },
    },
    methods: {
        closeAndEmit(){
            this.$emit('updated');
            this.resetForm();
        },
        detailsToFilters(invoice){
            if(typeof (invoice) != 'object' && !this.invoice) {
                return;
            } else if(typeof (invoice) != 'object') {
                invoice = this.invoice;
            }

            if(this.useInvoiceDetails) {

                if(invoice.PaymentType == 1) {
                    this.bankAccount = invoice.BillingAccountId;
                }
                this.currency = invoice.Currency;
                this.reportRange.start = moment(invoice.InvoiceDate).subtract(5, 'days').format('YYYY-MM-DD');
                this.reportRange.end = moment(invoice.InvoiceDate).add(30, 'days').format('YYYY-MM-DD');
                this.amountFrom = Math.floor(invoice.DueAmount * 0.9)
                this.amountTo   = Math.ceil(invoice.DueAmount * 1.1)
            } else {
                this.resetForm();
            }

        },

        syncAll() {
            this.$http
                .get(`transactions/importAll`)
                .then(data => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: this.successMessage(data),
                            icon: 'InfoIcon',
                            variant: 'success'
                        }
                    })
                    this.refetchData()
                }).catch(error => {
                if (error) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: this.errorMessage(error),
                            icon: 'InfoIcon',
                            variant: 'danger'
                        }
                    })
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: this.i18nT(`Something went wrong!`),
                            icon: 'InfoIcon',
                            variant: 'danger'
                        }
                    })
                }

            })
        },
        paymentTypeIcon(type) {
            switch (type) {
                case 'cash':
                    return 'money-bill-alt'
                case 'sepa_debit':
                    return 'piggy-bank'
                case 'card':
                    return 'credit-card'
                case 'bank':
                    return 'university'
                default:
                    return 'money-bill-alt'
            }
        },
        statusLabelClass(status) {
            return {
                'paid': 'success',
                'partial': 'warning',
                'not_paid': 'light-dark',
                'overdue': 'danger',
                'overpaid': 'info',
                'void': 'dark'
            }[status]
        },
        statusLabel(status){
            return {
                'paid': this.i18nT(`Paid`),
                'partial': this.i18nT(`Partial`),
                'not_paid': this.i18nT(`Not paid`),
                'void': this.i18nT(`Void`),
                'overpaid': this.i18nT(`Overpaid`),
                'overdue': this.i18nT(`Overdue`)
            }[status]
        },
        onTableRefresh() {
            this.selectedItems = []
        },
        rowClass(item) {
            if(item){
                return item.activeRow ? 'active-row' : ''
            }else {
                return '';
            }

        },
        onRowClicked(item, index) {
            let self = this;

            this.transactions.forEach((item, itemIndex) => {
                self.transactions[itemIndex].activeRow = false;
            });
            item.activeRow = true;
            this.selectedRow = item;
            this.selectedItems = [];
            this.availablePayments = [...this.invoice.InvoicePayments];
            this.availablePayments.push({
                Id: `0`,
                Amount: item.Amount,
                CreatedAt: item.TransactionDate,
                IsNew: true,
                Currency: item.Currency,
                PaymentType: 'bank',
                Description:item.Label
            });
            this.selectedRowIndex = index;
            this.selectedPreviousPayment = `0`;
            this.selectedItems = [`0`];
        },
        cancel() {
            this.resetForm();
            this.$refs.createInvoice.reset();
            this.$bvModal.hide('modal-link-transaction')
        },
        resetForm() {
            this.selectedRow = {};
            this.selectedItems = [];
            this.availablePayments = [];
            this.selectedPreviousPayment = null;
            this.selectedRowIndex = null;

            this.bankAccount = '';
            this.currency = '';
            this.reportRange.start = '';
            this.reportRange.end = '';
            this.amountFrom = '';
            this.amountTo = '';

            //this.$refs.createInvoice.reset();
        },
        postData(){
            let self= this;

            let formData = new FormData();
            formData.append('transaction_id', this.selectedRow.Id);
            formData.append('invoice_id', this.invoice.Id);
            if(this.selectedItems.length > 0){
                formData.append('payment_id', this.selectedItems[0]);
            }

            this.$http.post(`transactions/createPaymentForInvoice`, formData).then((response) => {
                self.$emit('ready');

                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.successMessage(response),
                        icon: 'CheckIcon',
                        variant: 'success',
                        message: this.i18nT(`Transaction successfully linked to payment!`)
                    },
                });

                this.$bvModal.hide('modal-invoice-transaction');

            }).catch((error) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: this.errorMessage(error),
                        icon: 'XIcon',
                        variant: 'danger',
                        message: this.i18nT(`Something went wrong!`)
                    },
                });
            })

        },
        linkToPayment() {

            if(this.dontRemind){
                this.postData()
            } else {
                this.$swal({
                    title: this.i18nT(`Disclaimer`),
                    icon: 'warning',
                    html: `
              <p>${this.i18nT(`You won't be able to delete an invoice after recording a payment!`)}</p>
              <div class="py-1">
              <input type="checkbox" id='dontRemind-transaction' class="sk-dontCheckbox" value="1" />
              <label for="dontRemind" class="ml-05">${this.i18nT(`Don't remind me again`)}</label>
              </div>`
                    ,
                    showCancelButton: true,
                    confirmButtonText: this.i18nT(`Record!`),
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                })
                    .then(result => {
                        if (result.value) {
                            if (document.getElementById('dontRemind-transaction').checked) {
                                this.dontRemind = document.getElementById('dontRemind-transaction').checked;
                                useAuth.setDontRemind({name: 'transaction', value: this.dontRemind})
                            }
                            this.postData()
                        }
                    })
            }
        },

    },
    setup() {
        const {
            fetchDocuments,
            bankAccount,
            currency,
            amountFrom,
            amountTo,
            matchedStatus,
            tableColumns,
            perPage,
            currentPage,
            totalDocuments,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refDocumentListTable,
            statusFilter,
            invoiceType,
            category,
            assignedTo,
            vendor,
            paymentType,
            transactions,
            documentFilter,
            startDate,
            endDate,
            refetchData
        } = useAbridgedTransactionList(true)

        return {
            fetchDocuments,
            bankAccount,
            currency,
            amountFrom,
            amountTo,
            matchedStatus,
            tableColumns,
            perPage,
            currentPage,
            totalDocuments,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refDocumentListTable,
            statusFilter,
            invoiceType,
            category,
            assignedTo,
            vendor,
            paymentType,
            startDate,
            endDate,
            avatarText,
            transactions,
            documentFilter,
            refetchData
        }
    },
    created() {
        this.$http.get(
            `system/paymentTypes`
        ).then(({ data }) => {
            this.paymentTypeList = dictToSelectArray(data.data)
        })

        this.dontRemind = useAuth.getDontRemind('transaction');

        this.bankAccounts.unshift({
            value: '',
            text: this.i18nT(`All`)
        })

        this.currencies.unshift({
            value: '',
            text: this.i18nT(`All`)
        })

        this.$http.get(`transactions/bankAccountsFilter`).then(({data}) => {
            this.bankAccounts.push(...dictToSelectArray(data.data))
        })

        this.$http.get(`transactions/currenciesFilter`).then(({data}) => {
            this.currencies.push(...dictToSelectArray(data.data))
        })



        let filterString = '';

        if(this.documentType == 1){
            filterString = '?invoicing=1';
        }

        this.invoiceType = { value: this.documentType, text: '' } ;

        this.$http.get(`vendors/vendorsList`+filterString).then(({data}) => {
            this.vendorList = dictToSelectArray(data.data)
            this.vendorList.unshift({
                value: -1,
                text: this.i18nT(`All`)
            })
        })

        let curWorkspace = useAuth.getCurWorkspace();
        this.vatPercent = curWorkspace.MainVatPercent;
    },
    watch: {
        invoice: {
            handler(val){
                if (val) {
                    this.detailsToFilters(val);
                }
            },
            deep: true,
        },
        selectedPreviousPayment(val){
            this.selectedItems = [val];
        },
        documentType(val){
            this.invoiceType = { value: val, text: '' } ;
        },
        documents(){
            this.availablePayments = [];
            this.selectedRow = {};
            this.selectedItems = [];
        },
        reportRange(newRange) {

            if (newRange) {

                if (newRange.start) {
                    this.startDate = moment(newRange.start).format('YYYY-MM-DD');
                }
                if (newRange.end) {
                    this.endDate = moment(newRange.end).format('YYYY-MM-DD');
                }

            } else {
                this.startDate = '';
                this.endDate = '';
            }

        },
    }
}
</script>

<style>

div.date-time-picker {
    width: calc(100% - 56px);
}
.date-time-picker input.field-input {
    padding-right: 5px;
}

.ctk-date-time-picker__header,
.datetimepicker .custom-button,
.datetimepicker span.custom-button-content,
.datepicker-buttons-container .datepicker-button.now .datepicker-button-content
{
    /* Change the header text color */
    color: #5a5aff !important;
    fill: #5a5aff !important;
}


#modal-link-transaction___BV_modal_content_ div.table-responsive {
    min-height: 200px;
}


#invoiceListTable.table th, #invoiceListTable.table td,
#paymentsListTable.table th, #paymentsListTable.table td{
    padding: 0.5em;
    font-size: 0.9em;
}

#invoiceListTable tr {
    transition: all 0.3s ease;
}

#invoiceListTable tr:hover {
    cursor: pointer;
    background-color: rgba(90, 90, 255, 0.1);
}

#invoiceListTable tr.active-row {
    background-color: rgba(90, 90, 255, 0.1);
}

.sk-dontCheckbox{
    position: relative;
    top: 2px;
}
</style>


<style scoped lang="scss">


.max-w-200 {
    max-width: 200px;
}
.plain-modal {
    background-color: var(--light-gray);
}

.discountIcon {
    position: relative;
    margin: 0 auto;
    margin-top: calc(50% - 1px);
}

.section-title {
    font-size: 11px;
}

.document-name {
    display: inline;
    line-height: 32px;
}

.document-actions-bar {
    float: right;
}
</style>
